
export default {
  // baseURL: "http://nbgextranet.lan/api/v1/", // something like "http://my-host-name.xyz/api"
  // baseURL: "https://extranet.52.62.245.144.nip.io/api/v1/", // something like "http://my-host-name.xyz/api"
  // baseURL: window.NBG_API_URL + 'api/v1/',
  // Not doing CORS any more - using reverse proxies instead
  baseURL: '/api/v1/',
  withCredentials: true,
}
